// Single logout path for both auth systems. Clears the full local session
// (app keys AND MSAL token cache, which lives in localStorage) BEFORE triggering
// any IdP redirect — otherwise the redirect can navigate away before cleanup
// runs, leaving stale tokens (idToken / msal.*) persisted in localStorage.
//
// - AAD: end the MSAL session via logoutPopup (also clears its cache), then route.
// - Auth0: wipe local storage first, then redirect to the Auth0 logout endpoint.
// Everything the app remembers about the signed-in person and their
// organisation. Cleared on sign-out AND at the start of every sign-in, so a
// second account in the same browser never inherits the first one's org name,
// feature set, company id or cached permissions.
export const SESSION_KEYS = [
  "userName", "loginType", "JWT", "companyName", "organization", "features", "companyid",
];
export function clearSessionState() {
  SESSION_KEYS.forEach((k) => localStorage.removeItem(k));
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith("perms:"))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch (e) {
    // sessionStorage unavailable — nothing to clear
  }
}

export function performLogout(msalInstance, auth0Logout, navigate) {
  const loginType = localStorage.getItem("loginType");
  clearSessionState();

  if (loginType === "AAD") {
    const accounts = msalInstance ? msalInstance.getAllAccounts() : [];
    if (msalInstance && accounts.length > 0) {
      // logoutPopup needs the account in cache — clear app keys only AFTER it
      // runs (it clears MSAL's own cache + ends the server session).
      msalInstance
        .logoutPopup({ account: accounts[0] })
        .catch(() => {})
        .finally(() => {
          localStorage.clear();
          navigate("/");
        });
    } else {
      localStorage.clear();
      navigate("/");
    }
    return;
  }

  // Auth0 (or unknown): clear FIRST so nothing lingers if the redirect fires.
  localStorage.clear();
  if (auth0Logout) {
    auth0Logout({ logoutParams: { returnTo: window.location.origin } });
  } else {
    navigate("/");
  }
}
